import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext, useState } from 'react';
import { Dialog } from '../../ui/Dialog';
import { FuelTransaction, EditFuelTransaction as EditFuelTransactionType } from '../../../types/FuelTransaction';
import { useForm } from 'react-hook-form';
import { editFuelTransactionSchema } from '../validation/editFuelTransactionSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../ui/Form';
import { Input } from '../../ui/Input';
import { useFuelTransaction } from '../hooks/useFuelTransaction';
import { toast } from 'react-toastify';
import { UserContext } from '../../../context/UserProvider';
import { Role } from '../../../types/Role';
import { Button } from '../../ui/Button';
import { Textarea } from '../../ui/Textarea';

export const EditFuelTransaction = ({ fuelTransaction }: { fuelTransaction: FuelTransaction }) => {
    const { userRole } = useContext(UserContext);
    const [isOpen, setIsOpen] = useState(false);
    const form = useForm<z.infer<typeof editFuelTransactionSchema>>({
        resolver: zodResolver(editFuelTransactionSchema),
        defaultValues: {
            kilometersTotal: fuelTransaction.changeRequest?.kilometersOld.amount || Number(fuelTransaction.kilometersTotal.amount),
            remark: '',
        },
    });
    const editMutation = useFuelTransaction().editFuelTransaction();

    const onSubmit = async (values: Omit<EditFuelTransactionType, 'id'>) => {
        editMutation.mutate(
            { id: fuelTransaction.id, ...values },
            {
                onSuccess: () => {
                    setIsOpen(false);

                    toast(userRole !== Role.ADMIN ? 'Je aanpassingsverzoek is ingediend.' : 'Kilometerstand succesvol aangepast.');
                },
            },
        );
    };

    return (
        <>
            <Button.Icon onClick={() => setIsOpen(true)} aria-label="edit" title="Aanpassen">
                <FontAwesomeIcon icon={faPencil} className="text-lg" />
            </Button.Icon>

            <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
                <Dialog.Title>Tankbeurt aanpassen</Dialog.Title>
                <Form {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-3">
                        <FormField
                            control={form.control}
                            name="kilometersTotal"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Totale kilometerstand</FormLabel>
                                    <FormControl>
                                        <Input placeholder="Kilometerstand" {...field} type="number" step={1} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />
                        <FormField
                            control={form.control}
                            name="remark"
                            render={({ field }) => (
                                <FormItem>
                                    <FormLabel>Opmerking (optioneel)</FormLabel>
                                    <FormControl>
                                        <Textarea placeholder="Opmerking (optioneel)" {...field} />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />

                        <div className="flex justify-end pt-6">
                            <Button loading={editMutation.isPending}>Opslaan</Button>
                        </div>
                    </form>
                </Form>
            </Dialog>
        </>
    );
};
